import { client } from "../lib";

export const getSampleDocuments = async () => {
    return await client.fetch(`*[_type == "sampleDocument"]{
        title,
        "docUrl": document.asset->url,
        "size": document.asset->size
    }`);
};